import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessPartnerQuery } from '@/__generated__/businessPartnerQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { PartnerContainer } from '@/components/survey/business/partner/PartnerContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { partnerQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function BusinessPartnerPage() {
  const eventAttributes = useSurveyUserEventAttributes();
  const [queryRef, loadQuery] = useQueryLoader<businessPartnerQuery>(partnerQuery);
  const bmanTin = useAtomValue(currentBusinessBmanTinAtom);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);

  useEffect(() => {
    if (bmanTin && refundHistoryId) {
      loadQuery(
        {
          refundHistoryId,
          bmanTin
        },
        { fetchPolicy: 'network-only' }
      );
    }
  }, [loadQuery, bmanTin, refundHistoryId]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_partner'} eventProperty={eventAttributes}>
      <PartnerContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

BusinessPartnerPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default BusinessPartnerPage;
